/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function (_, stringResources, React, PropTypes, Toolkit) {

	const {
		AutoCompleteInput,
		FlexLayout,
		Label
	} = Toolkit;

	class ContextSection extends React.Component {
		static propTypes = {
			value: PropTypes.string,
			values: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired
				}).isRequired
			).isRequired,
			onValueChange: PropTypes.func.isRequired
		}

		constructor(props) {
			super(props);
			this.state = this._buildStateFromProps();
		}

		componentDidUpdate(prevProps) {
			if (prevProps.value !== this.props.value) {
				this.setState(this._buildStateFromProps());
			}
		}

		_buildStateFromProps() {
			//`value` state represents the text the user has typed - it doesn't necessarily represent a meaningful column;
			//it is distinct from `value` prop which the id of the latest selected column
			return { value: this.props.value ? this.getLabel(this.props.value) : '' };
		}

		render() {
			const values = this.getValues().map(({ label }) => label);
			return (
				<FlexLayout
					className="contextSection"
					fullHeight
					direction='column'
					justifyContent='space-between'
				>
					<Label
						className='aName'
						label={stringResources.get('searchByLabel')}
						title={stringResources.get('searchColumnAriaLabel')}
						type='caption'
					/>
					<AutoCompleteInput
						ariaLabel={stringResources.get('searchColumnAriaLabel')}
						placeHolderText={stringResources.get('searchColumn')}
						values={values}
						value={this.state.value}
						onChange={value => this.setState({ value })}
						onSelectionChange={value => this.onSelectionChange(value)}
						light
					/>
				</FlexLayout>
			);
		}
		getValues() {
			//Detect ambiguous labels. (More than one identical label.)
			const labels = {};
			this.props.values.forEach(
				({ label }) => {
					if(labels[label]) {
						//There are multiple occurences of this label
						labels[label].ambiguous = true;
					} else {
						//The first occurrence of a label
						labels[label] = { ambiguous: false };
					}
				}
			);

			return this.props.values.map(
				({ id, label }) => ({
					id,
					label: labels[label].ambiguous ? `${label} (${id})` : label
					// When translated, replace `${label} (${id})` with:
					// stringResources.get('searchColumnQualifiedLabel', { label, id })
				})
			);
		}
		getLabel(entryId) {
			const entry = this.getValues().find(({ id }) => id == entryId);
			return entry && entry.label;
		}
		getId(entryLabel) {
			const entry = this.getValues().find(({ label }) => label == entryLabel);
			return entry && entry.id;
		}
		onSelectionChange(value) {
			const id = this.getId(value);
			if(this.props.value !== id) {
				//Actual change - propogate to owner
				this.props.onValueChange(id);
			} else {
				//Newly entered value is actually the one already selected
				//No actual change - but the text field may be incomplete,
				//so update state
				this.setState({
					value
				});
			}

		}
	}

	return ContextSection;
});
